import { Expose, Type } from "class-transformer";
import { FileDto } from "@/core/features/file/file.dto";

export class UserHasQualificationFileListItemDto {
  @Expose()
  id: string;

  @Expose()
  qualificationName: string;

  @Expose()
  @Type(() => Date)
  start: Date;

  @Expose()
  @Type(() => FileDto)
  file: FileDto;
}
